import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const UserGuideSidebar = withSafeSuspense(
  lazy(
    () => import(/* webpackChunkName: 'user_guide_sidebar' */'./sidebar')
      .then((module) => ({ default: module.UserGuideSidebar }))
  ), null
)
